<template>
<div class="icon" :class="{'iborder':IconBorder }" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
      <path d="M11.18,14.356c0-1.451,1.1-2.254,2.894-3.442C16.268,9.458,19,7.649,19,3.354c0-0.387-0.317-0.699-0.709-0.699h-3.43
		C14.377,1.759,12.932,0.8,10,0.8c-2.934,0-4.377,0.959-4.862,1.855H1.707C1.316,2.655,1,2.968,1,3.354
		c0,4.295,2.73,6.104,4.926,7.559c1.794,1.188,2.894,1.991,2.894,3.442v1.311c-1.884,0.209-3.269,0.906-3.269,1.736
		c0,0.994,1.992,1.799,4.449,1.799c2.457,0,4.449-0.805,4.449-1.799c0-0.83-1.385-1.527-3.269-1.736V14.356z M13.957,9.3
		c0.566-1.199,1.016-2.826,1.088-5.246h2.51C17.315,6.755,15.693,8.118,13.957,9.3z M10,2.026c2.732-0.002,3.799,1.115,3.798,1.529
		c0,0.418-1.066,1.533-3.798,1.535C7.268,5.089,6.201,3.974,6.201,3.556C6.2,3.142,7.268,2.024,10,2.026z M2.445,4.054h2.509
		C5.027,6.474,5.475,8.101,6.043,9.3C4.307,8.118,2.684,6.755,2.445,4.054z"/></svg>
</div>

</template>

<script>
export default {
  props: {
  IconBorder: Boolean
}
}
</script>

